<template>
  <button
    @click="fullscreenToggle"
    class="fullscreen-button"
    :class="[customClass, statusClass, buttonHoverClass]"
    :aria-label="fullScreenAriaLabel"
  >
    <Icon :name="fullscreenIcon" :color="iconVariant" focusable="false" />
  </button>
</template>

<script>
import { Icon } from '../Icon';
import Fullscreen from './FullscreenManager';

export default {
  name: 'FullscreenButton',
  components: { Icon },
  data() {
    return {
      isFullscreen: false,
      statusClass: this.getStatusClass(),
    };
  },
  props: {
    customClass: {
      type: String,
      default: '',
    },
    fullscreenIconInactive: {
      type: String,
      default: 'fullscreen',
    },
    fullscreenIconActive: {
      type: String,
      default: 'fullscreen',
    },
    buttonTextMaximized: {
      type: String,
      default: 'Maximize Screen',
    },
    buttonTextMinimized: {
      type: String,
      default: 'Restore Screen',
    },
    iconVariant: {
      type: String,
      required: false,
      default: '#ffffff',
    },
    iconVariantHover: {
      type: String,
      required: false,
      default: 'dark-pink',
    },
  },
  mounted() {
    this.fullscreen.onFullscreenchange = () => {
      this.isFullscreen = this.fullscreen.isFullscreen;
      this.statusClass = this.getStatusClass();
    };
  },
  computed: {
    fullscreen() {
      return Fullscreen;
    },
    fullscreenIcon() {
      return this.isFullscreen
        ? this.fullscreenIconActive
        : this.fullscreenIconInactive;
    },
    fullScreenAriaLabel: function () {
      return this.isFullscreen
        ? this.buttonTextMinimized
        : this.buttonTextMaximized;
    },
    buttonHoverClass() {
      return `content-svg-${this.iconVariantHover}-hover`;
    },
  },
  methods: {
    fullscreenToggle: function () {
      this.fullscreen.toggle();
    },
    getStatusClass: function () {
      return this.isFullscreen ? 'fullscreen-active' : 'fullscreen-inactive';
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "./full_screen_button.styl";
</style>
